<template>
    <div class="handbook">
        <div class="hugescreen"></div>
        <div class="menu">
            <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
                <el-menu-item index="北京">北京</el-menu-item>
                <el-menu-item index="内蒙古">内蒙古</el-menu-item>
            </el-menu>
        </div>
        <div class="file_list flex-align-between">
            <div class="category">
                <div class="category_title flex-align-between">
                    <div class="category_l">
                        <img src="../../assets/handbook/pdf_icon.png" alt="">
                        <span>操作手册</span>
                    </div>
                    <div class="category_r flex-align">
                        更多>
                    </div>
                </div>
                <div class="line"></div>
                <div class="eachbox">
                    <div class="each flex-align-between" v-for="(item, index) in ResourceList[activeIndex]['pdf_list']"
                        @click="gopdf(item.file)">
                        <div class="flie_name flex-align">
                            <div class="icon"></div>
                            <div class="eachname"> {{ item.name }}</div>
                        </div>
                        <div class="date">{{ item.date }}</div>
                    </div>
                </div>

            </div>
            <div class="category">
                <div class="category_title flex-align-between">
                    <div class="category_l">
                        <img src="../../assets/handbook/video_icon.png" alt="">
                        <span>操作视频</span>
                    </div>
                    <div class="category_r flex-align">
                        更多>
                    </div>
                </div>
                <div class="line"></div>
                <div class="eachbox">
                    <div class="each flex-align-between" v-for="(item, index) in ResourceList[activeIndex]['video_list']"
                        @click="govideo(item.file)">
                        <div class="flie_name flex-align">
                            <div class="icon"></div>
                            <div class="eachname"> {{ item.name }}</div>
                        </div>
                        <div class="date">{{ item.date }}</div>
                    </div>
                </div>

            </div>
        </div>
        <div class="file_list flex-align-center" v-if="false">
            <el-empty description="暂未开放"></el-empty>
        </div>
    </div>
</template>

<script>
export default {
    //import引入组件才能使用
    components: {},
    props: {},
    data() {
        return {
            activeIndex: '北京',
            ResourceList: {
                '北京': {
                    'pdf_list': [
                        {
                            name: '平台使用手册（面向北京市区级教育部门管理者）',
                            date: '2024-04-17',
                            file: '1'
                        },
                        {
                            name: '平台使用手册（面向北京学校管理者）',
                            date: '2024-04-17',
                            file: '2'
                        },
                        {
                            name: '平台使用手册（面向北京学校教师）',
                            date: '2024-04-17',
                            file: '3'
                        },
                    ],
                    'video_list': [
                        {
                            name: '平台使用视频（面向北京市区级教育部门管理者）',
                            date: '2024-04-17',
                            file: '1'
                        },
                        {
                            name: '平台使用视频（面向北京学校管理者）',
                            date: '2024-04-17',
                            file: '2'
                        },
                        {
                            name: '平台使用视频（面向北京学校教师）',
                            date: '2024-04-17',
                            file: '3'
                        },
                    ]
                },
                '内蒙古': {
                    'pdf_list': [
                        {
                            name: '平台使用手册（面向内蒙古各盟市旗县教育部门管理者）',
                            date: '2024-04-17',
                            file: '1'
                        },
                        {
                            name: '平台使用手册（面向内蒙古学校管理者）',
                            date: '2024-04-17',
                            file: '2'
                        },
                        {
                            name: '平台使用手册（面向内蒙古学校教师）',
                            date: '2024-04-17',
                            file: '3'
                        },
                    ],
                    'video_list': [
                        {
                            name: '平台使用视频（面向内蒙古各盟市旗县教育部门管理者）',
                            date: '2024-04-17',
                            file: '1'
                        },
                        {
                            name: '平台使用视频（面向内蒙古学校管理者）',
                            date: '2024-04-17',
                            file: '2'
                        },
                        {
                            name: '平台使用视频（面向内蒙古学校教师）',
                            date: '2024-04-17',
                            file: '3'
                        },
                    ]
                }
            },
        };
    },
    // 计算属性
    computed: {
    },
    // 监听data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        handleSelect(key, keyPath) {
            console.log(key);
            this.activeIndex = key;
        },
        gopdf(index) {
            let routeData = this.$router.resolve({
                path: '/help_pdf',
                query: {
                    fileName: this.activeIndex,
                    fileIndex: index
                }
            });
            window.open(routeData.href, '_blank');
        },
        govideo(index) {
            let routeData = this.$router.resolve({
                path: '/help_video',
                query: {
                    fileName: this.activeIndex,
                    fileIndex: index,

                }
            });
            window.open(routeData.href, '_blank');
        }
    },
    // 生命周期，创建完成时（可以访问当前this实例）
    created() {

    },
    // 生命周期：挂载完成时（可以访问DOM元素）
    mounted() {
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.$store.state.user.token == null ? next('/home/page') : next();
        })
    },
    beforeCreate() { },//生命周期：创建之前
    beforeMount() { },//生命周期：挂载之前
    beforeUpdate() { },//生命周期：更新之前
    updated() { },//生命周期：更新之后
    beforeDestroy() { },//生命周期：销毁之前
    destroyed() { },//生命周期：销毁完成
    activated() { },//如果页面有keep-alive缓存功能，这个函数会触发执行
}
</script>
<style lang="less" scoped>
@import './less/handbook.less';
</style>